import Slider from 'components/Slider'
import Panel from 'components/Panel'
import Slide from 'components/DeviceSlider/Slide'

const FreeNavSlider = ({
  devices,
  isFetching,
  handleClick,
  productNamePlural
}) => {
  if (devices.length === 0) {
    return null
  }

  const slides = devices.map((device) => (
    <div key={device.id}>
      <Slide device={device} handleClick={handleClick} />
    </div>
  ))

  return (
    <Panel
      title={
        productNamePlural
          ? `Free Navigation ${productNamePlural}`
          : 'Free Navigation Products'
      }
    >
      {!isFetching && <Slider>{slides}</Slider>}
    </Panel>
  )
}

export default FreeNavSlider
